/**
 * External dependencies
 */
import React, { useState } from "react";
import { map, includes } from "lodash";

/**
 * Internal dependencies
 */
import TableRenderer from "components/charts/table-renderer";
import Modal from "components/modal";
import LineChartRenderer from "components/charts/line-chart-renderer";
import QueryCubeJS from "data/query-cube-js";
import { renderRecharts } from "../utils";
import Button from "components/button";

// This overrides the default table to add more features
// specifically; this adds a time series popup for the category when clicked

const categoriesWithPopover = [
  "Saleitem.name",
  "Saleitem.sku",
  "Saleitem.category",
  "Saleitem.department",
  "Saleitem.supplier",
];

const CustomTableRenderer = (props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [seriesQuery, setSeriesQuery] = useState(null);
  const seriesNames = map(props.resultSet.seriesNames(), "key");

  const handleCategoryClick = ({ value, column, ...rest }) => {
    // remove the unwanted fields
    let { rowLimit, order, ..._query } = props.resultSet.query();

    const category = column.key;
    _query.dimensions = [];
    _query.filters = [
      { dimension: category, operator: "equals", values: [value] },
    ];
    _query.order = {};

    // finally open the modal
    setSeriesQuery(_query);
    setModalOpen(true);
  };

  const columnRenderer = ({ formattedValue, value, column, row }) => {
    if (
      false === seriesNames.includes(column.key) &&
      true === includes(categoriesWithPopover, column.key)
    ) {
      return (
        <Button
          text
          onClick={() => handleCategoryClick({ value, column, row })}
        >
          {formattedValue}
        </Button>
      );
    }
    return formattedValue;
  };

  return (
    <>
      <TableRenderer {...props} columnRenderer={columnRenderer} />
      {modalOpen && (
        <Modal
          header={false}
          className="report__time-series-popover"
          close={() => setModalOpen(false)}
          isVisible={modalOpen}
        >
          <QueryCubeJS
            query={seriesQuery}
            timeSeries={true}
            render={renderRecharts((response) => {
              return (
                <LineChartRenderer
                  dataType="time_series"
                  points={false}
                  {...response}
                  compare={props.compare}
                />
              );
            })}
            queryPreviousRange={props.compare}
            applyDashboardFilters={false}
            timeDimension={props.timeDimension}
          />
        </Modal>
      )}
    </>
  );
};

export default CustomTableRenderer;
